import { defineAsyncComponent } from "vue";

export default {
  AppLayout: defineAsyncComponent({
    loader: () => import("shared-ui/layouts/AppLayout.vue"),
    suspensible: false,
  }),
  RegistrationLayout: defineAsyncComponent({
    loader: () => import("@/layouts/RegistrationLayout.vue"),
    suspensible: false,
  }),
  LoginLayout: defineAsyncComponent({
    loader: () => import("@/layouts/LoginLayout.vue"),
    suspensible: false,
  }),
};
